import { toast } from 'react-toastify';

// موفقیت
export const showSuccess = (message, options = {}) => {
    toast.success(message, {
        position: 'top-center',
        autoClose: 3000,
        theme: "dark",
        ...options,
    });
};

// خطا
export const showError = (error, options = {}) => {
    let message = 'درخواست با خطا مواجه شد. لطفا دوباره تلاش کنید';

    if (typeof error === 'string') {
        message = error;
    } else if (error?.response?.data?.message) {
        message = error.response.data.message;
    } else if (error?.message) {
        message = error.message;
    }

    toast.error(message, {
        position: 'top-center',
        autoClose: 4000,
        theme: 'dark',
        ...options,
    });
};

// اخطار
export const showWarning = (message, options = {}) => {


    toast.warning(message, {
        position: 'top-center',
        autoClose: 4000,
        theme: 'dark',
        ...options,
    });
};
